import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { fonts } from "theme/fonts";
import { firebase, EventContext, UserContext, AnalyticsContext } from "context";
import { useDocumentData } from "react-firebase-hooks/firestore";

export const PoweredBy = ({ zipCode, postCampaign }) => {
  const [dealer, setDealer] = useState();
  const [fdaf, loading, error] = useDocumentData(
    firebase.firestore().doc(`geo/ford/fdaf/${zipCode}`)
  );

  let string = fdaf?.fdaf;
  useEffect(() => {
    if (string) {
      let newStr = string
        .replace("Dealers", "")
        .replace("Greater Texas Ford", "Best In Texas Ford Dealers")
        .replace("North Texas Ford", "Your North Texas Ford Dealers")
        .replace("Houston Ford", "Best In Texas Ford Dealers")
        .replace("Cincinnatti North Ford", "Local Ford Dealer")
        .replace("Cincinnati North Ford", "Local Ford Dealer");
      setDealer(newStr);
    }
  }, [string]);

  if (loading) return null;

  return (
    <PoweredByWrapper postCampaign={postCampaign}>
      <SubBody>
        Powered by Your {dealer ? dealer : "Local Ford Dealers"}
      </SubBody>
    </PoweredByWrapper>
  );
};
const topBorder = `
  border-top: 1px solid #707070;
  padding-top: 24px;
  margin-top: 24px;
`;

const PoweredByWrapper = styled.div`
  ${topBorder}
  ${(props) => props.postCampaign && "border-top: 0px solid #707070;"}
`;
const SubBody = styled.p`
  font-size: 0.65rem;
  @media (max-width: 950px) {
    font-size: 0.9rem;
  }
`;
